import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { routing } from './bonus-routing.module';
import { BonusComponent } from './bonus.component';
import { SharedModule } from '../../shared/shared.module';
import { BonusSettingComponent } from './promotion/bonus-setting/bonus-setting.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BonusHistoryComponent } from './permanent/bonus-history/bonus-history.component';
import { BonusTopLossHistoryComponent } from './bonus-top-loss-history/bonus-top-loss-history.component';
import { BonusTopPlHistoryComponent } from './bonus-top-pl-history/bonus-top-pl-history.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { BonusCommonSettingComponent } from './permanent/bonus-common-setting/bonus-common-setting.component';
import { CalendarModule } from 'primeng/calendar';
import { BonusCodeHistoryComponent } from './promotion/bonus-code-history/bonus-code-history.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BonusTreeviewComponent } from './promotion/tree/bonus-treeview.component';
import { BonusNetworkComponent } from './promotion/tree/bonus-network.component';
import { CheckboxModule } from 'primeng/checkbox';
import { PermanentComponent } from './permanent/permanent.component';
import { IbBonusComponent } from './permanent/ib-bonus/ib-bonus.component';
import { BonusSettingDetailComponent } from './promotion/bonus-setting-detail/bonus-setting-detail.component';
import {  DynamicDialogConfig, DynamicDialogModule  } from 'primeng/dynamicdialog';
import { ConfirmPromotionComponent } from './promotion/bonus-setting-detail/confirm-promotion/confirm-promotion.component';
import { PreviewMailTemplateComponent } from './promotion/preview-mail-template/preview-mail-template.component';

@NgModule({
  declarations: [
    BonusComponent,
    BonusSettingComponent,
    BonusHistoryComponent,
    BonusTopLossHistoryComponent,
    BonusTopPlHistoryComponent,
    BonusCommonSettingComponent,
    BonusCodeHistoryComponent,
    BonusTreeviewComponent,
    BonusNetworkComponent,
    PermanentComponent,
    IbBonusComponent,
    BonusSettingDetailComponent,
    ConfirmPromotionComponent,
    PreviewMailTemplateComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    CalendarModule,
    AutoCompleteModule,
    CheckboxModule,
    SharedModule,
    DynamicDialogModule,
    routing,
  ],
  providers:[DynamicDialogConfig]
})
export class BonusModule {}
